export var checkIfMobile = function () {
    try {
        return window.innerWidth < 768;
    }
    catch (e) {
        return false;
    }
};
//# sourceMappingURL=utils.js.map